export const shouldDisplayCorporatePrices = user => {
  return user?.attributes?.email?.includes('@decathlon.');
};
